import Image from 'next/image';
import styles from './DesignCategory.module.css';
import { LeadPopUpButton } from '../shared/lead/LeadPopUpButton';
import { ElemenetType } from '@/lib/constants';

type props = {
    widgetData: { text: string, image: string, buttonText: string, cssClass?: string }
}
export function DesignCatsNewWidgets({ widgetData }: props) {
    return (
        <div className={styles.ctaTile}>
            <div className={`${styles.contentBox} ${widgetData.cssClass && styles[widgetData.cssClass]}`}>
                <Image width={widgetData.cssClass ? 224 : 100} height={widgetData.cssClass ? 180 : 95} src={`/assets/images/${widgetData.image}`} alt="bedrooom" />
                <span dangerouslySetInnerHTML={{ __html: widgetData.text }} />
            </div>
            <LeadPopUpButton ElemenetType={ElemenetType.button} ButtonClass="btn bgPink textfff font16">
                {
                    widgetData.buttonText
                }
            </LeadPopUpButton>
        </div>
    )
}